import { ReportAggregation, Tenant, TenantPermissions, User, UserRole } from '@domain/graphql.types';
import { createContext } from 'react';

export type UserContextProps = {
  error: Error | undefined;
  initializationCompleted: boolean;
  initializeUser: () => void;
  isEmailVerified: boolean;
  isInvitedUser: boolean;
  isLoading: boolean;
  hasFinishedOnboarding: boolean;
  hasSupportForAggregation: (aggregation: ReportAggregation) => boolean;
  refreshUser: () => void;
  user: User | undefined;
  role: UserRole | undefined;
  tenant: Tenant | undefined;
  tenantPermissions: TenantPermissions | undefined;
  version: string | null;
};

const UserContext = createContext<UserContextProps>({
  error: undefined,
  initializationCompleted: false,
  initializeUser: () => {},
  isEmailVerified: false,
  isInvitedUser: false,
  isLoading: false,
  hasFinishedOnboarding: false,
  hasSupportForAggregation: () => false,
  refreshUser: () => {},
  user: undefined,
  role: undefined,
  tenant: undefined,
  tenantPermissions: undefined,
  version: null,
});

export default UserContext;
